import { setupApp } from '@/server/setupApp';
import {
  getActiveRoomsByTellerId,
  getCategories,
  getCouponCodeByCode,
  getFortuneMethods,
  getFutureSchedulesByTellerId,
  getPublicPlansByTellerId,
  getReviewsOrderByTextCountPriorityProfileHighlight,
  getTeller,
} from '@raysee/firestore';
import { isDisabledTeller } from '@raysee/schema';
import Page from 'src/pages/tellers/[tellerId]';

export const getServerSideProps = async ({ query }) => {
  setupApp();
  const { tellerId, code } = query as { tellerId: string; code: string };
  const [teller, plans, reviews, schedules, rooms, categories, fortuneMethods, couponCodes] =
    await Promise.all([
      getTeller(tellerId),
      getPublicPlansByTellerId(tellerId),
      getReviewsOrderByTextCountPriorityProfileHighlight({
        tellerId,
        limitNum: 30,
      }),
      getFutureSchedulesByTellerId(tellerId),
      getActiveRoomsByTellerId(tellerId),
      getCategories(),
      getFortuneMethods(),
      getCouponCodeByCode(code),
    ]);
  if (isDisabledTeller(teller)) return { notFound: true };
  return {
    props: {
      teller,
      plans,
      reviews,
      schedules,
      rooms,
      categories,
      fortuneMethods,
      couponCode: couponCodes[0] ?? null,
    },
  };
};

export default Page;
